<template>
  <div :class="$style.container">
    <Loading v-if="initialing" :size="100" backgroundColor="#eee" />
    <div :class="$style.filtercontainer" v-if="!initialing">
      <MapFilter :groups="internalFilterGroups" @change="handleFilterChange" />
    </div>
    <div :class="$style.contentContainer">
      <div v-html="state.introText" :class="$style.intro" />
      <div :class="$style.mapcontainer" v-if="!initialing" ref="mapContainer">
        <Loading v-if="loading" :size="100" backgroundColor="#eee" />
        <Map
          :mapZoom="initialZoom"
          :markers="internalMarkers"
          @loadingChange="handleLoadingChange"
          :legendItems="state.legend"
          :useForm="config.useForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Map from "../Map/Map";
import MapFilter from "../MapFilter/MapFilter";
import Loading from "../Loading/Loading";

export default {
  name: "MapFilterApp",
  components: {
    Map,
    MapFilter,
    Loading
  },
  props: {
    state: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      initialing: true,
      loading: true,
      internalMarkers: [],
      internalFilterGroups: [],
      initialZoom: this.state.initialZoom
    };
  },
  methods: {
    handleLoadingChange(value) {
      this.loading = value;
    },
    handleFilterChange(filterGroupId, itemId, itemActive) {
      const foundGroup = this.internalFilterGroups.filter(
        filterGroup => filterGroup.id === filterGroupId
      )[0];

      const foundFilter = foundGroup.items.filter(
        item => item.id === itemId
      )[0];

      foundFilter.active = itemActive;

      this.setInternalMarker();

      if (window.matchMedia("(max-width: 767px)").matches) {
        this.$refs.mapContainer.scrollIntoView({
          behavior: "smooth",
          block: "end"
        });
      }
    },
    setInternalMarker() {
      const markers = this.state.contacts.filter(marker => {
        let foundInGroups = 0;
        this.internalFilterGroups.forEach(filterGroup => {
          let foundInGroup = 0;
          const markerFilterGroup = marker.filterGroups[filterGroup.id];
          filterGroup.items.forEach(f => {
            if (f.active) {
              if (markerFilterGroup.indexOf(f.id) !== -1) {
                foundInGroup++;
              }
            }
          });

          foundInGroup > 0 && foundInGroups++;
        });

        return foundInGroups === this.internalFilterGroups.length;
      });

      this.internalMarkers = markers;
    },
    setAllFilterActive() {
      this.internalFilterGroups = this.state.filterGroups.map(group => ({
        ...group,
        items: group.items.map(item => ({
          ...item,
          active: true
        }))
      }));
    },
    init() {
      this.setAllFilterActive();
      this.setInternalMarker();
      this.initialing = false;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style module lang="scss">
@import "./MapFilterApp.scss";
</style>
